import { Input } from '@/common/components/Input.tsx'
import { Form } from '@/common/components/Form.tsx'
import { usStates } from '@/common/constants.ts'
import { WizardBodyContainer } from '@/app/pages/program_applications/vendor_application/components/WizardBodyContainer.tsx'
import { WizardStepTitle } from '@/app/pages/program_applications/vendor_application/components/WizardStepTitle.tsx'
import { WizardStepContent } from '@/app/pages/program_applications/vendor_application/components/WizardStepContent.tsx'
import { WizardFooter } from '@/app/pages/program_applications/vendor_application/components/WizardFooter.tsx'
import { useWizardContext } from '@/app/pages/program_applications/vendor_application/WizardProvider.tsx'
import { useTranslation } from 'react-i18next'

export default function BusinessAddress() {
  const { t: translate } = useTranslation()
  const { goNext } = useWizardContext()
  const validateForm = () => {
    goNext()
  }
  return (
    <>
      <WizardBodyContainer>
        <WizardStepTitle>{translate('business_info')}</WizardStepTitle>
        <WizardStepContent>
          <div className="max-w-xl mx-auto">
            <h1 className="font-semibold text-lg text-gray-600 mb-4">
              {translate('business_service_address')}
            </h1>
            <Form>
              <div className="flex flex-col space-y-2">
                <div>
                  <label
                    htmlFor="address"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    {translate('address')}
                    <span className="text-danger ml-1">*</span>
                  </label>
                  <div className="mt-2">
                    <Input
                      id="address"
                      name="address"
                      type="text"
                      autoComplete="street-address"
                      required
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="city"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    {translate('city')}
                    <span className="text-danger ml-1">*</span>
                  </label>
                  <div className="mt-2">
                    <Input
                      id="city"
                      name="city"
                      type="text"
                      autoComplete="address-level2"
                      required
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="state"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    {translate('state')}
                    <span className="text-danger ml-1">*</span>
                  </label>
                  <div className="mt-2">
                    <select
                      id="state"
                      name="state"
                      autoComplete="address-level1"
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:max-w-xl sm:text-sm sm:leading-6"
                    >
                      {usStates.map((state) => (
                        <option
                          key={state.abbreviation}
                          value={state.abbreviation}
                        >
                          {state.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="zip"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    {translate('zip')}
                    <span className="text-danger ml-1">*</span>
                  </label>
                  <div className="mt-2">
                    <Input
                      id="zip"
                      name="zip"
                      type="number"
                      autoComplete="postal-code"
                      required
                    />
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </WizardStepContent>
      </WizardBodyContainer>
      <WizardFooter onNext={validateForm} />
    </>
  )
}
